import { render, staticRenderFns } from "./GenealogyPersonSearchInput.vue?vue&type=template&id=3ab9bb44&scoped=true&"
import script from "./GenealogyPersonSearchInput.vue?vue&type=script&lang=ts&"
export * from "./GenealogyPersonSearchInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab9bb44",
  null
  
)

export default component.exports